import React, { useEffect, useState } from "react";
import useDocumentTitle from "../../../../../hooks/useDocumentTitle";
import { useParams } from "react-router-dom";
import DownloadablePage from "../../../../../components/DownloadablePage";
import PlantModuleNav from "../../../../../components/PlantModuleNav";
import { secondAxios } from "../../../../../api/axios";
import ReconcileTab from "./ReconcileTab";
import { Box } from "@mui/material";
import ValidationHeader from "./ValidationHeader";
import CompareTab from "./CompareTab";
import SearchTab from "./SearchTab";
import { ValidationContextProvider } from "./validation.context";

export default function ValidationPage() {
  useDocumentTitle("Validation Tool");
  const { plantId } = useParams();

  const [viewMode, setViewMode] = useState("Reconcile");

  const [plant, setPlant] = useState({ projects: [] });
  const [state, setState] = useState({
    loading: false,
    isError: false,
  });

  const fetchPlant = async () => {
    try {
      setState({ isLoading: true, isError: false });
      const res = await secondAxios.get("/plant/" + plantId + "/mcs");
      console.log("plant for validation: ", res?.data);
      setPlant({ ...plant, ...res.data });
    } catch (err) {
      console.error("Error fetching plants:", err);
      setState({ isLoading: false, isError: true });
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    fetchPlant();
  }, []);

  return (
    <ValidationContextProvider>
      <DownloadablePage fileName={`Validation-PLANT-${plant?.name}`}>
        {plantId && <PlantModuleNav plantId={plantId} floating compact />}

        <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1800, mx: "auto" }}>
          <ValidationHeader
            plant={plant}
            activeMode={viewMode}
            onModeChange={(e, newMode) => setViewMode(newMode)}
          />
          {viewMode === "Reconcile" ? (
            <ReconcileTab plant={plant} />
          ) : viewMode === "Compare" ? (
            <CompareTab />
          ) : (
            <SearchTab />
          )}
        </Box>
      </DownloadablePage>
    </ValidationContextProvider>
  );
}
